import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  @keyframes placeHolderShimmer {\n    0% {\n      background-position: -468px 0;\n    }\n    100% {\n      background-position: 468px 0;\n    }\n  }\n\n  animation-duration: inherit;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n  animation-name: placeHolderShimmer;\n  background: ", ";\n  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);\n  position: relative;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  animation-duration: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { whiteSmoke } from '../../styles/colors';
export var ShimmerWrapper = styled.div(_templateObject(), function (_ref) {
  var animationDuration = _ref.animationDuration;
  return animationDuration && "".concat(animationDuration, "s");
});
export var Shimmer = styled.div(_templateObject2(), function (_ref2) {
  var width = _ref2.width;
  return width && "width: ".concat(width, "px");
}, function (_ref3) {
  var height = _ref3.height;
  return height && "height: ".concat(height, "px");
}, whiteSmoke);